import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    single: {
      order: translate({ id: 'deleteOrderModal.targetRange.order' }),
      future: translate({ id: 'deleteOrderModal.targetRange.future' }),
      all: translate({ id: 'deleteOrderModal.targetRange.all' }),
    },
    bulk: {
      order: translate({ id: 'deleteOrderModal.targetRange.order.bulk' }),
      future: translate({ id: 'deleteOrderModal.targetRange.future.bulk' }),
      all: translate({ id: 'deleteOrderModal.targetRange.all.bulk' }),
    },
    disabledFutureTooltip: translate({
      id: 'deleteOrderModal.targetRange.future.disabled.tooltip',
    }),
    disabledFutureTooltipForLastOccurrenceDelete: translate({
      id: 'deleteOrderModal.targetRange.future.lastOccurrence.disabled.tooltip',
    }),
  }))

  return api
}
